import { inject, Injectable, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorage } from '../helpers/localstorage.helper';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // renderer = inject(Renderer2)
    private _initialDarkModeValue: boolean = false;
  constructor() {
    const mediaQuery : MediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    
    // mediaQuery.addEventListener('change', (event) => {
    //   console.log('Changed mode:', event.matches ? 'Dark' : 'Light');
    // });

    const storedTheme = LocalStorage.get('isDarkMode');
    if (storedTheme !== null) {
      this._initialDarkModeValue = storedTheme;
      this.toggleDarkMode(this._initialDarkModeValue);
    }else{
      this._initialDarkModeValue = mediaQuery.matches
    }
  }



  private _darkMode = new BehaviorSubject<boolean>(this._initialDarkModeValue);
  public isDarkMode = this._darkMode.asObservable();

  toggleDarkMode(isDarkMode: boolean = this._initialDarkModeValue): void {
    LocalStorage.set('isDarkMode', isDarkMode);
    let praimaryColor

    this._darkMode.next(isDarkMode);
    if (isDarkMode) {
      // this.renderer.addClass(document.body, 'dark-theme');
      document.body.classList.add('dark-theme');
      document.documentElement.classList.add('p-dark');
      praimaryColor = getComputedStyle(window.parent.document.documentElement).getPropertyValue('--color-brand-300');
    }
    else {
      // this.renderer.removeClass(document.body, 'dark-theme');
      document.body.classList.remove('dark-theme');
      document.documentElement.classList.remove('p-dark');
      praimaryColor = getComputedStyle(window.parent.document.documentElement).getPropertyValue('--color-brand-600');
    }

    document.documentElement.style.setProperty('--praimary-color', praimaryColor);
  }
}